"use client";
import type { FeaturedProductsProps } from "@/components/FeaturedProducts/types";
import CTALink from "@/components/CTA/ctaLink";
import { ElementType } from "@/constants/tagular/main";
import { validateLocation } from "@/utils/functions/validateLocation";

type DegreeCurriculumProps = FeaturedProductsProps & {
  title?: string;
};

export const DegreeCurriculumCTA = (props: DegreeCurriculumProps) => {
  const isValidLocation = validateLocation(
    props.locationRestrictions?.allowedIn || [],
    props.locationRestrictions?.blockedIn || [],
  );

  return (
    <div className="bg-putty-100">
      <div className="container w-full bg-putty-100">
        {isValidLocation && props.ctaLabel && props.ctaUrl && (
          <>
            {props.ctaHeader && (
              <h2 className="w-full text-center justify-center mb-4">
                {props.ctaHeader}
              </h2>
            )}
            <div className="flex items-center justify-center">
              <CTALink
                type="brand"
                size="xl"
                label={props.ctaLabel}
                url={props.ctaUrl}
                icon="arrow-right"
                element_type={ElementType.Button}
                {...props}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
};
